import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ShareListingModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ShareListingModalContainer" */
      './ShareListingModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
